export const SIGNUP_SUCCESS = "SIGNUP_SUCCESS";
export const SIGNUP_FAILURE = "SIGNUP_FAILURE";
export const SET_USER = "SET_USER";
export const CLEAR_MESSAGE = "CLEAR_MESSAGE";
export const SET_MESSAGE = "SET_MESSAGE";
export const UPDATE_LOADING = "UPDATE_LOADING";
